import type MarkdownIt from 'markdown-it';
import type StateCore from 'markdown-it/lib/rules_core/state_core.mjs';
import type Token from 'markdown-it/lib/token.mjs';

const CHART_REGEX = /\[\^(chart)\^\]/;

const visualizationChart = (state: StateCore) => {
	const tokens: Token[] = [];
	let chartCounter = 0;

	for (const token of state.tokens) {
		const tokenChildren: Array<Token | null> = [];

		if (token.type !== 'inline' || (token.children && token?.children?.length <= 0)) {
			tokens.push(token);
			continue;
		}

		if (token.children) {
			token.children.forEach((childToken) => {
				if (childToken.type === 'text' && CHART_REGEX.test(childToken.content)) {
					const parts = childToken.content.split(CHART_REGEX);
					parts.forEach((part, index) => {
						if (index % 2 === 0) {
							const textToken = new state.Token('text', '', 0);
							textToken.content = part;
							textToken.level = childToken.level;
							tokenChildren.push(textToken);
						} else {
							// Create a new token for each chart match
							const chartToken = new state.Token('status', '', 0);
							chartToken.content = '';
							chartToken.block = false;
							chartToken.level = childToken.level;
							chartToken.attrs = [
								['localId', 'chart-' + chartCounter],
								['text', 'loading chart-' + chartCounter],
								['color', 'blue'],
							];
							tokenChildren.push(chartToken);
							chartCounter++;
						}
					});

					return;
				}

				tokenChildren.push(childToken);
			});
		}

		const filteredTokenChildren = tokenChildren.filter(
			(childToken) => childToken !== null,
		) as Token[];
		token.children = filteredTokenChildren;
		tokens.push(token);
	}

	state.tokens = tokens;
	return;
};

export default function mdPluginVisualizationChart(md: MarkdownIt): void {
	md.core.ruler.push('chart', visualizationChart);
}
